// Both legal pages are repo-managed in-app routes (src/pages/legal/
// PrivacyPolicyPage.tsx and TermsOfServicePage.tsx) served at
// <origin>/privacy-policy and <origin>/terms-of-service, so we link to them
// on whatever origin the app runs on (app.schedulehero.ai in prod, or a
// white-label partner's own domain — the same React app serves the pages
// either way, and both pages are brand-aware via branding.companyName).
//
// Terms previously pointed at the GoHighLevel-hosted marketing site
// (www.schedulehero.ai/terms-of-service); it was ported into the repo as
// part of the GHL cutover, so both links are now origin-relative.

export function getLegalUrls(branding: { baseUrl: string }): {
  privacyPolicy: string;
  termsOfService: string;
} {
  return {
    // In-app, repo-managed, CTIA-compliant privacy policy.
    privacyPolicy: `${branding.baseUrl}/privacy-policy`,
    // In-app, repo-managed terms (includes the Section 4 consent-to-
    // communications clause A2P registration relies on).
    termsOfService: `${branding.baseUrl}/terms-of-service`,
  };
}
